import OrderStageAccordion from "../../components/OrderStageAccordion";
import VideoEditing from "./VideoEditing/VideoEditing";
import { useEffect, useState } from "react";
import usePolling from "@/hooks/usePolling"; // Assuming you're using a custom polling hook
import useOrderVideoParams from "@/hooks/useOrderVideoParams";
import {
  RequiredEditingStageActions,
  TOrderVideoStatus,
  TResponseOrderDetails,
  TVideoEditing,
} from "@/types/projectType";
import { useGetVideoEditingQuery } from "@/redux/feature/orderManagement/videoEditing/videoEditingApi";

const EditingStage = ({
  data,
  disabled,
  requiredActions,
  VideoStageStatus,
}: {
  disabled: boolean;
  requiredActions: RequiredEditingStageActions[];
  VideoStageStatus: TOrderVideoStatus;
  data: TResponseOrderDetails;
}) => {
  const { videoId, orderId } = useOrderVideoParams();
  // Initialize `isOpen` based on the editing stage status
  const [isOpen, setIsOpen] = useState(false);
  const requiredActionsForCurrentVideo = requiredActions.find(
    (item) => item.videoId === videoId
  )?.adminRequiredActions?.required;

  const pollingTemplates = {
    videoEditing: [
      "client-video-setup-revision-requested-001",
      "client-video-editing-approved-001",
      "admin-recording-stage-completed-008"
    ],
  };
  // Centralized polling interval logic
  const videoEditingPollingInterval = usePolling({
    templateIds: pollingTemplates.videoEditing,
  }).pollingInterval;

  // Fetch video editing data with polling
  const { data: videoEditingData } = useGetVideoEditingQuery(
    { orderId, videoId },
    {
      skip: !isOpen,
      refetchOnMountOrArgChange: true,
      pollingInterval: videoEditingPollingInterval,
    }
  );

  useEffect(() => {
    if (VideoStageStatus?.stage_status.recording_stage?.inProgress) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [VideoStageStatus?.stage_status.recording_stage?.inProgress]);

  return (
    <OrderStageAccordion
      disabled={disabled}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      isProgress={VideoStageStatus?.stage_status?.editing_stage?.inProgress}
      completed={VideoStageStatus?.stage_status?.editing_stage?.completed}
      title="Editing stage"
      stageNumber={3}
      initiallyOpen={VideoStageStatus?.stage_status?.editing_stage?.inProgress}
    >
      <div className="mt-5 space-y-4">
        <VideoEditing
          ActionsRequired={requiredActionsForCurrentVideo}
          videoEditingData={videoEditingData?.data as TVideoEditing}
        />
        {/* Footer with Submit Button */}
        <div className="bg-[#F5F9FF] p-3 rounded-bl-xl rounded-br-xl flex justify-end items-center">
          <button className="text-white text-sm px-3 py-2 font-semibold rounded-lg bg-[#1018280D]">
            Submit
          </button>
        </div>
      </div>
    </OrderStageAccordion>
  );
};

export default EditingStage;
